document.addEventListener('DOMContentLoaded', function () {

    // parallax-effect for multiple items 
    const sections = document.querySelectorAll('.parallax-effect');
    sections.forEach((section) => {
        if (section) {
            const items = section.querySelectorAll('.item');
            const contentWithImage = section.classList.contains('content-with-image');
            const imageWithCta = section.classList.contains('image-with-cta');
            const cta = section.classList.contains('cta');
            const teamFilter = section.classList.contains('team-filter');
            const colTwoWithImage = section.classList.contains('col-two-with-image');
            const contentWithToggle = section.classList.contains('content-with-toggle');

            // Define the reference screen height and scroll speeds
            const referenceHeight = 985;
            let referenceScrollSpeeds;

            if (contentWithImage) {
                referenceScrollSpeeds = [5, 11];
            }

            if (imageWithCta) {
                referenceScrollSpeeds = [5, 9, 13];
            }

            if (cta) {
                referenceScrollSpeeds = [5];
            }

            if (colTwoWithImage) {
                referenceScrollSpeeds = [5];
            }

            if (contentWithToggle) {
                referenceScrollSpeeds = [7];
            }

            if (teamFilter) {
                referenceScrollSpeeds = [7, 13, 14];
            }

            // if (heroBanner) {
            //     referenceScrollSpeeds = [5];
            // }

            // Function to calculate dynamic scroll speeds
            function getScrollSpeeds() {
                const currentHeight = window.innerHeight; // Get the current screen height
                const scalingFactor = currentHeight / referenceHeight; // Calculate scaling factor

                // Return dynamically adjusted scroll speeds
                return referenceScrollSpeeds.map(speed => speed * scalingFactor);
            }

            function handleScroll() {
                const scrollPos = window.scrollY;
                const height = window.innerHeight;
                const windowWidth = window.innerWidth;
                const scrollSpeeds = getScrollSpeeds(); // Get the dynamically adjusted scroll speeds

                items.forEach((item, index) => {
                    if (window.innerWidth > 767) {  // Apply styles only if window width is greater than 767px
                        const parent = item.parentNode;
                        const parentRect = parent.getBoundingClientRect();
                        const parentHeight = parentRect.height;
                        const parentTop = parentRect.top;

                        let translate;
                        if (windowWidth > 991) {
                            translate = (parentTop - height) / scrollSpeeds[index];
                        } else {
                            translate = (parentTop - height) / scrollSpeeds[index]; // Adjust speed for each item
                        }

                        // Only apply the transformation if the item is in the viewport
                        if (parentTop < height) {
                            item.style.transform = `translateY(${translate}px)`;
                        }
                    } else {
                        // Reset styles if window width is less than or equal to 767px
                        item.style.transform = '';
                    }
                });
            }

            // Run the function on scroll
            window.addEventListener('scroll', handleScroll);

            // Run the function initially to set styles correctly based on the current window size
            handleScroll();

            // Optionally, run handleScroll on window resize to recalculate scroll speeds and positions
            window.addEventListener('resize', handleScroll);
        }
    });
});

